import { postCirugia } from "./ApiHIS"

export const postPrincipalFormasFarmaceuticas=(body)=>{
    return postCirugia('suministros/formasFarmaceuticas/obtenerFormasFarmaceuticasPrincipal',body)
}

export const postObtenerFormasFarmaceuticasViasAplicacion=(body)=>{
    return postCirugia('suministros/formasFormaceuticas/obtenerFormasFarmaceuticasViasAplicacion', body)
}

export const postInsertUnaFormaFarmaceuticaYViasAplicacion=(body)=>{
    return postCirugia('suministros/formasFormaceuticas/insertarUnaFormaFarmaceuticaYViasAplicacion',body)
}

export const postViasAplicionFormasFarmaceuticas=(body)=>{
    return postCirugia('suministros/formasFormaceuticas/obtenerViasAplicacion', body)
}

export const postInsertarUnaViaAplicacion=(body)=>{
    return postCirugia('suministros/formasFormaceuticas/insertarUnaViaAplicacion',body)
}

export const postActualizarFormasFarmaceuticas=(body)=>{
    return postCirugia('suministros/formasFormaceuticas/actualizarFormasFarmaceuticas',body)
}

export const postDeleteFormasFarmaceuticasYViasAplicacion=(body)=>{
    return postCirugia('suministros/formasFormaceuticas/eliminarFormasFarmaceuticasYViasAplicacion',body)
}

export const postEliminarUnaViaAplicacion=(body)=>{
    return postCirugia('suministros/formasFormaceuticas/eliminarUnaViaAplicacion',body)
}

//Maestro concentracion
export const postConsultarMaestroConcentracion=(body)=>{
    return postCirugia('suministros/maestroConcentracion/obtenerMaestroConcentracionPrincipal',body)
}

export const postModificarMaestroConcentracion=(body)=>{
    return postCirugia('suministros/maestroConcentracion/actualizarMaestroConcentracion',body)
}

export const postInsertarMaestroConcentracion=(body)=>{
    return postCirugia('suministros/maestroConcentracion/insertarMaestroConcentracion',body)
}

export const postEliminarMaestroConcentracion=(body)=>{
    return postCirugia('suministros/maestroConcentracion/eliminarMaestroConcentracion',body)
}